import { render, staticRenderFns } from "./thirdpartyTagManage_old.vue?vue&type=template&id=131e4a9a&scoped=true&"
import script from "./thirdpartyTagManage_old.vue?vue&type=script&lang=js&"
export * from "./thirdpartyTagManage_old.vue?vue&type=script&lang=js&"
import style0 from "./thirdpartyTagManage_old.vue?vue&type=style&index=0&id=131e4a9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e4a9a",
  null
  
)

export default component.exports